export default __webpack_public_path__ + "static/media/illucidvv2.96f584d3.png";